export default {"src":"/_next/static/media/apis.a1a07092.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};